/* eslint-disable*/
import traceit from './traceit'
import traceitReact from './traceit-react'
import React from 'react'

const traceitClient  = traceit({
    endpoints: {
    notify: `${process.env.REACT_APP_CRM_BASE_URL}/Common/UIlog`,
    sessions: '',
    },
    appName: 'IHX Portal',
    appModuleName:'Module name',
    appVersion: '1.2.3',
    deliveryStage: 'development',
    user: {},
    customData: {
        company: {
          name: 'IHX'
        }
      },

    apiKey: 'for future use',
    appType: 'Web App',
    autoNotify: false,
    autoRecordActivites: true,
    recordNetworkActivity: true,
    recordConsoleActivity: true,
    recordUserInteractionActivity: true,
    recordNavigationActivity: true,
    autoRecordSessions: false,
    maxActivities: 40, // default 20
    maxEvents: 50, // default 100
    collectUserIp: true,
    notifyDeliveryStages: ['development', 'production', 'staging'],
    captureInlineScripts: true
  });
  traceitClient.use(traceitReact, React);

export default traceitClient
